/* src/app/private/components/leads/lead-followup-form-popup/lead-followup-form-popup.component.scss */
.title {
  text-align: left;
  font-weight: 600;
}
/*# sourceMappingURL=lead-followup-form-popup.component.css.map */
